'use client';

import { useEffect } from 'react';

import { useTranslations } from '@/hooks/useTranslations';
import { Button } from '@/components/ui';

export default function ErrorComponent({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { translations } = useTranslations('error_page');

  // Translation constants with fallbacks
  const title = translations?.title || 'Something went wrong!';
  const tryAgain = translations?.try_again || 'Try again';

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center space-y-3 pt-20">
      <h2>{title}</h2>
      <Button variant="outline" onClick={() => reset()}>
        {tryAgain}
      </Button>
    </div>
  );
}
